import { render } from "./variant.vue?vue&type=template&id=94d545ba&scoped=true&ts=true"
import script from "./variant.vue?vue&type=script&lang=ts"
export * from "./variant.vue?vue&type=script&lang=ts"

import "./variant.vue?vue&type=style&index=0&id=94d545ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94d545ba"]])

export default __exports__